import Link from "@/components/AppLink";
import { getDashboardPathUrl } from "@/config/dashboardOrigin";

const CallToAction = () => {
  return (
    <section className="call-action-inner index4">
      <div className="overlay pt-120">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="bottom-area">
                <div className="row justify-content-center">
                  <div className="col-lg-6 text-center">
                    <h3>Need help routing your first wire or ACH batch?</h3>
                    <Link href={getDashboardPathUrl("/register-2")} className="cmn-btn create">
                      Create Account Now
                    </Link>
                    <Link href="/contact" className="cmn-btn get">
                      Get in touch
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CallToAction;
